/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const upsertSocietaSmtpConfigurationRequestSchema = z.object({
  host: z.coerce.string(),
  port: z.coerce.number().int().optional(),
  authEnabled: z.boolean().optional(),
  username: z.coerce.string().nullable().nullish(),
  password: z.coerce.string().nullable().nullish(),
  clearPassword: z.boolean().optional(),
  senderEmail: z.coerce.string(),
  senderName: z.coerce.string().nullable().nullish(),
  socketSecurity: z
    .enum(['auto', 'startTls', 'sslOnConnect', 'none'])
    .optional(),
});
